import { BlockComponentModel } from '@/cms/types/blok-component';
import { ImageStrapi as ImageStrapiTypes } from '@/cms/types/image';

import { ImageBlock } from '@/blocks/imageBlock';
import Image, { NextImageProps } from '@/components/atoms/Image';
import { transformCMSAssetToNextImageProps } from './utils';

export interface ImageStrapiProps {
  image?: {
    data?: {
      attributes?: ImageStrapiTypes;
    };
  };
  altText?: string;
  isExpandable?: boolean;
}

export { transformCMSAssetToNextImageProps };

export default function ImageStrapi({
  block,
  inner,
  width,
  height,
}: BlockComponentModel<ImageStrapiProps, NextImageProps> & {
  width?: number;
  height?: number;
}) {
  const props = transformCMSAssetToNextImageProps(block);

  if (!props || !props.src) {
    return null;
  }

  if (block.isExpandable) {
    const size = {
      width: width || inner?.width || props?.width,
      height: height || inner?.height || props?.height,
    };

    return (
      <ImageBlock
        image={<Image {...props} {...inner} {...size} />}
        expandedImage={
          <Image
            {...props}
            {...inner}
            classNames={{ image: 'max-w-[540px] max-h-[460px]' }}
            {...size}
          />
        }
        isExpandable={true}
      />
    );
  }

  return (
    <Image
      {...props}
      {...inner}
      width={width || inner?.width || props?.width}
      height={height || inner?.height || props?.height}
    />
  );
}
